export const GRID = 24;
export const WORLD = 20000;
export const MIN_ZOOM = 0.15;
export const MAX_ZOOM = 3;

export const NOTE_COLORS = {
  lavender: { bg: "#ede9fe", ink: "#3b1d8f", ring: "#c4b5fd" },
  mint: { bg: "#dcfce7", ink: "#14532d", ring: "#86efac" },
  peach: { bg: "#ffedd5", ink: "#7c2d12", ring: "#fdba74" },
  sky: { bg: "#e0f2fe", ink: "#0c4a6e", ring: "#7dd3fc" },
  rose: { bg: "#fce7f3", ink: "#831843", ring: "#f9a8d4" },
  sun: { bg: "#fef9c3", ink: "#713f12", ring: "#fde047" },
  ink: { bg: "#0b0f1a", ink: "#ffffff", ring: "#7c3aed" },
  white: { bg: "#ffffff", ink: "#0b0f1a", ring: "#e2e8f0" },
};

export const fileUrl = (u) => (u && u.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${u}` : u);
export const domainOf = (u) => { try { return new URL(u).hostname.replace(/^www\./, ""); } catch { return u; } };
export const snap = (v) => Math.round(v / GRID) * GRID;
export const center = (it) => ({ x: it.x + it.w / 2, y: it.y + it.h / 2 });
export const uid = () => Math.random().toString(36).slice(2, 10) + Date.now().toString(36).slice(-4);

export const DEFAULT_SIZE = {
  note: { w: 240, h: 170 }, text: { w: 320, h: 80 }, link: { w: 260, h: 110 }, image: { w: 280, h: 220 }, file: { w: 240, h: 96 },
  shape: { w: 200, h: 140 }, frame: { w: 720, h: 480 }, checklist: { w: 260, h: 200 }, comment: { w: 240, h: 120 }, cpenz: { w: 280, h: 150 },
};

/** Point on the border of `it` towards `to` (so connectors touch the card edge, not its center). */
export function anchor(it, to) {
  const c = center(it), dx = to.x - c.x, dy = to.y - c.y;
  if (!dx && !dy) return c;
  const sx = (it.w / 2) / Math.abs(dx || 1e-6), sy = (it.h / 2) / Math.abs(dy || 1e-6);
  const s = Math.min(sx, sy);
  return { x: c.x + dx * s, y: c.y + dy * s };
}

export const rectsIntersect = (a, b) => a.x < b.x + b.w && a.x + a.w > b.x && a.y < b.y + b.h && a.y + a.h > b.y;
export const contains = (frame, it) => it.x >= frame.x && it.y >= frame.y && it.x + it.w <= frame.x + frame.w && it.y + it.h <= frame.y + frame.h;

export function boundsOf(items) {
  if (!items.length) return { x: 0, y: 0, w: 1200, h: 800 };
  const x1 = Math.min(...items.map((i) => i.x)), y1 = Math.min(...items.map((i) => i.y));
  const x2 = Math.max(...items.map((i) => i.x + i.w)), y2 = Math.max(...items.map((i) => i.y + i.h));
  return { x: x1, y: y1, w: x2 - x1, h: y2 - y1 };
}
